import { render, staticRenderFns } from "./AlternateAddressForm.vue?vue&type=template&id=c2e3b94e"
import script from "./AlternateAddressForm.vue?vue&type=script&lang=js"
export * from "./AlternateAddressForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports